// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isComponent(arg) {
    return !!arg && typeof arg.render === 'function';
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isHTMLElement(arg) {
    return !!arg && typeof arg.getBoundingClientRect === 'function';
}
//# sourceMappingURL=reflect.js.map